<div class="field field-text" [ngClass]="typeClass">
  @if (label) {
    <span class="label">{{label}} @if (optionalString) {
      <span>({{optionalString}})</span>
    }</span>
  }
  <div class="d-flex align-items-center w-100">
    <input
      [class.error-field]="error"
      type="text"
      class="flex-grow-1"
      [(ngModel)]="localModel"
      (blur)="onBlur($event)"
      (ngModelChange)="onChange()"
      (keyup.enter)="onBlur(null); enter.emit()"
      [placeholder]="placeholder ?? ''"
      [disabled]="disabled"
      [attr.data-1p-ignore]="ignorePassword ? '' : null"
      />
    <!-- button -->
    @if (afterString) {
      <span class="after-string passive-gray">{{afterString | display}}</span>
    }
  </div>
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }
</div>